import http from 'services/http-service';

const StoreOrderService = {
    GetAll(status: number, skipCount: number, maxResultCount: number, keyword: string) {
        let response = http.get('/storeorders/all/admin', { params: { skipCount: skipCount, maxResultCount: maxResultCount, status: status, keyword: keyword } });
        return response;
    },

    Get(orderId: any) {
        let response = http.get(`/storeorders/${orderId}/admin`);
        return response;
    },

    PayManual(id: string, logosBankAccountId: string, bankName: string, bankAccountName: string, bankAccountNumber: string, amount: any, screenshot: any) {
        let formData = new FormData();
        formData.append("id", id);
        formData.append("logosBankAccountId", logosBankAccountId);
        formData.append("bankName", bankName);
        formData.append("bankAccountName", bankAccountName);
        formData.append("bankAccountNumber", bankAccountNumber);
        formData.append("screenshot", screenshot);
        formData.append("amount", amount);

        var result = http.post("/storeorders/paymanual", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    UpdateAirwayBill(orderId: any, airwayBill: string) {
        let response = http.put(`/storeorders/airwaybill`, { id: orderId, airwayBill: airwayBill });
        return response;
    },

    MarkAsComplete(orderId: any) {
        let response = http.put(`/storeorders/${orderId}/complete`);
        return response;
    }
};

export default StoreOrderService;